import { debounce } from "lodash";
import { useEffect, useRef } from "react";
const ScrollPositionMemory = {};
export function raf(cb) {
    let tick = false;
    return ()=>{
        if (tick) {
            return 0;
        }
        tick = true;
        return window.requestAnimationFrame(()=>{
            tick = false;
            cb();
        });
    };
}
export function useScrollPosition(name) {
    const scrollPosition = useRef(null);
    useEffect(()=>{
        const handleScroll = debounce(raf(()=>{
            const { scrollY  } = window;
            scrollPosition.current = scrollY;
        }), 100);
        var _ScrollPositionMemory_name;
        const _cachedScrollPosition = (_ScrollPositionMemory_name = ScrollPositionMemory[name]) !== null && _ScrollPositionMemory_name !== void 0 ? _ScrollPositionMemory_name : 0;
        window.scrollTo(0, _cachedScrollPosition);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
            if (scrollPosition.current !== null) {
                ScrollPositionMemory[name] = scrollPosition.current;
            }
        };
    }, [
        name
    ]);
    return;
}
